import { useMutation } from '@tanstack/react-query';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { BitbucketOAuthSessionCreateRequest } from '../httpClients/RepositoryClient/api.schema';
import { MUTATION_KEYS } from './consts';

export const useBitbucketOAuthSessionCreateMutation = () =>
  useMutation({
    mutationKey: [MUTATION_KEYS.BITBUCKET_OAUTH_SESSION_CREATE],
    mutationFn: (payload: BitbucketOAuthSessionCreateRequest) =>
      RepositoryClient.bitbucketOAuthSessionCreate(payload),
  });
